<div class="modal-wrapper sm:max-w-md" [ngClass]="'md:max-w-' + (options?.size || 'lg')">
    <!-- modal close button -->
    <div *ngIf="options?.closeModal || false">
        <img src="assets/icons/cancel.svg" alt="Cancel Icon" class="modal-close-icon rtl:mr-auto! rtl:ml-0! mb-4"
            (click)="close()" />
    </div>
    <!-- header icon -->
    <img *ngIf="options?.headerIconPath" [src]="options?.headerIconPath" alt="Icon" class="mb-8 mx-auto w-20 h-20" />

    <h3 class="mb-2 modal-title">{{ options?.title | translate }}</h3>
    <p class="mb-6 text-(--text-muted) text-center font-medium leading-6 text-base mx-2" *ngIf="options?.message"
        style="white-space: pre-line;">{{ options?.message |
        translate}} <span *ngIf="options?.messageInfo" class="font-semibold">{{options?.messageInfo}}</span>&nbsp; <span
            *ngIf="options?.messageRemaining" class="">{{options?.messageRemaining | translate}}</span></p>

    <p class="click-text text-center my-6!" *ngIf="options?.linkText" (click)="options?.linkAction()">
        {{options?.linkText | translate}}</p>

    <app-button *ngIf="options?.showConfirmButton" [text]="options?.textConfrimButton | translate" type="button"
        variant="primary" size="lg" (action)="confirm()" extraClass="mt-8"></app-button>

    <app-button *ngIf="options?.showCancelButton" [text]="options?.textCancelButton | translate" type="button"
        variant="outline" size="lg" (action)="cancel()" extraClass="mt-4"></app-button>
</div>